import React from 'react';
import TextField from '@mui/material/TextField';
import FormDialog from './FormDialog';

/**
 * CreateNoteDialog - Dialog for creating notes
 * @param {boolean} open - Whether the dialog is open
 * @param {string} noteText - Current note text value
 * @param {Function} onNoteTextChange - Callback when note text changes
 * @param {Function} onClose - Callback when dialog is closed
 * @param {Function} onSave - Callback when save is confirmed
 * @param {boolean} loading - Whether save is in progress
 */
export default function CreateNoteDialog({
  open,
  noteText,
  onNoteTextChange,
  onClose,
  onSave,
  loading = false
}) {
  return (
    <FormDialog
      open={open}
      title="Add Note"
      onClose={onClose}
      onConfirm={onSave}
      confirmLabel="Save"
      loading={loading}
    >
      <TextField
        autoFocus
        margin="dense"
        label="Note"
        fullWidth
        multiline
        rows={4}
        variant="outlined"
        value={noteText}
        onChange={(e) => onNoteTextChange(e.target.value)}
        disabled={loading}
        placeholder="Enter your note here..."
      />
    </FormDialog>
  );
}
